// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-pages-container {
    display: flex;
    justify-content: center;
    -webkit-user-select: none;
            user-select: none;
    
  }
  
  .pdf-page {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    width: 80%;
    object-fit: scale-down;
  }
  
  .react-pdf__Page__canvas {
      width: 100% !important;
      height: 100% !important;
  }
  
  .controls {
    margin: 20px;
    margin-top: 50px;
  }
  
  @media print {
    .pdf-container {
      display: none;
    }
  }
  
  button{
    border-radius:10px;
  }`, "",{"version":3,"sources":["webpack://./src/PdfViewer-orizzontal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAiB;YAAjB,iBAAiB;;EAEnB;;EAEA;IACE,sCAAsC;IACtC,mBAAmB;IACnB,UAAU;IACV,sBAAsB;EACxB;;EAEA;MACI,sBAAsB;MACtB,uBAAuB;EAC3B;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,kBAAkB;EACpB","sourcesContent":[".pdf-pages-container {\n    display: flex;\n    justify-content: center;\n    user-select: none;\n    \n  }\n  \n  .pdf-page {\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n    margin-bottom: 10px;\n    width: 80%;\n    object-fit: scale-down;\n  }\n  \n  .react-pdf__Page__canvas {\n      width: 100% !important;\n      height: 100% !important;\n  }\n  \n  .controls {\n    margin: 20px;\n    margin-top: 50px;\n  }\n  \n  @media print {\n    .pdf-container {\n      display: none;\n    }\n  }\n  \n  button{\n    border-radius:10px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
